import { render } from "./Marc.vue?vue&type=template&id=61231de0&scoped=true"
import script from "./Marc.vue?vue&type=script&lang=js"
export * from "./Marc.vue?vue&type=script&lang=js"

import "./Marc.vue?vue&type=style&index=0&id=61231de0&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61231de0"]])

export default __exports__